export default {"src":"/_next/static/media/congratsicon.d78d3a9a.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};